/**
 * @summary - Component that Provides Asset QR Code Genaration
 * @author Narasimman
 * @since 2024-08-23
 */
import React, { useEffect, useState, useRef } from "react";
import { DefaultCard } from "../../assets/styled-components/card";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { Box, Stack, Button, Grid, IconButton, Modal, Typography } from "@mui/material";
import SectionTitle from "../commoncomponents/SectionTitle";
import { useNavigate } from "react-router-dom";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import axios from "axios";
import { getAuthToken, getFacilityId, getcompanyId, getuserId, } from "../../utility/tokenUtility";
import CloseIcon from "@mui/icons-material/Close";
import QRCode from "qrcode.react"; // Import QR Code library
import { fetchServiceOptions } from "./GetLov";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import { useReactToPrint } from 'react-to-print';
import CustomDialog from "../commoncomponents/CustomDialog";

function CreateAssetQrCode() {

  const token = getAuthToken("id_token");
  const facilityId = getFacilityId();
  const companyid = getcompanyId();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [service, setService] = useState("");
  const [serviceOptions, setServiceOptions] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [groupOptions, setGroupOptions] = useState([
    { id: 1, value: "New Asset", label: "New Asset " },
    { id: 2, value: "Old Asset", label: "Old Asset" },
    { id: 3, value: "Asset Type Code", label: "Asset Type Code" },
    { id: 4, value: "Location", label: "Location" },
    { id: 5, value: "Department", label: "Department" },
  ]);
  const [groupDesc, setGroupDesc] = useState(
    { label: "", value: "" }
  );
  const [groupDescriptionOptions, setGroupDescriptionOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [openQrCodeModal, setOpenQrCodeModal] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    service: "",
    assetgroup: "",
    groupDesc: ""
  });
  const [errorMessages, setErrorMessages] = useState({
    service: "",
    assetgroup: "",
    groupDesc: ""
  });
  const [isChanged, setIsChanged] = useState(false);
  const serviceAutofoc = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [qrCodeData, setQrCodeData] = useState([]); // State to hold QR code data
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDialog, setContentDialog] = useState("");
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [codeLabel, setCodeLabel] = useState("");
  const printRefs = useRef();

  const qrCodeModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: "10px",
  };

  //Get all Lov's
  useEffect(() => {
    serviceAutofoc.current.focus();
    const getData = async () => {
      try {
        const services = await fetchServiceOptions();
        setServiceOptions(services);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getData();
  }, []);

  const colDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      minWidth: 80,
      maxWidth: 80,
      width: 80,
      filter:false,
    },
    { field: 'assetCode', headerName: 'Asset No.', width: 150 },
    { field: 'assetTypeCode', headerName: 'Asset Type Code', width: 180 },
    { field: 'assetDesc', headerName: 'Asset Description', width: 150 },
    { field: 'manufacturer', headerName: 'Manufacture', width: 150 },
    { field: 'model', headerName: 'Model', width: 150 },
    { field: 'userDeptDesc', headerName: 'Department Name', width: 150 },
    { field: 'userLocationDesc', headerName: 'Location Name', width: 150 },
  ];

  const handleServiceChange = (newValue) => {
    setIsChanged(true);
    setService(newValue);
    if (!service) {
      setErrors((prev) => ({ ...prev, service: false }));
      setErrorMessages((prev) => ({ ...prev, service: "" }));
    }
  };
  const handleGroupbyChange = (newValue) => {
    setIsChanged(true);
    setGroupName(newValue);
  
    const suffix = newValue?.label === 'Location' || newValue?.label === 'Department' || newValue?.label === 'Asset Type Code'
      ? ''
      : ' No.';
  
    setCodeLabel(newValue?.label + suffix);
  
    if (!groupName) {
      setErrors((prev) => ({ ...prev, groupName: false, groupDesc: false })); // Clear both groupName and groupDesc errors
      setErrorMessages((prev) => ({ ...prev, groupName: "", groupDesc: "" })); // Clear error messages
    }
  
    // Reset groupDesc when groupby changes
    setGroupDesc({ label: '' });
  };


  const handleGroupDescChange = (newValue) => {
    setGroupDesc(newValue);
  
    // Reset error when a valid groupDesc value is selected
    if (newValue && newValue.label) {
      setErrors((prev) => ({ ...prev, groupDesc: false }));
      setErrorMessages((prev) => ({ ...prev, groupDesc: "" }));
    }
  };
  

  useEffect(() => {
    if (groupName && service) {
      const fetchAssetList = async () => {
        const graphApi = service.value === 'FEMS' ? FemsGraph : BemsGraph;

        const assetCondition = groupName.id === 3
          ? `${graphApi}/api/AssetQRCode/GetAssetListFetch/${companyid}/3`
          : `${graphApi}/api/AssetQRCode/GetAssetListFetch/${facilityId}/${groupName.id}`;

        try {
          const response = await axios.get(assetCondition, config);
          const groupDesc1 = response.data;
          const groupDescOptions = groupDesc1.map((gd) => ({
            value: gd.code,
            label: `${gd.code} - ${gd.description}`,
            id: gd.id,
          }));
          setGroupDescriptionOptions(groupDescOptions);
        } catch (error) {
          console.error("Error fetching asset list:", error);
        }
      };

      fetchAssetList();
    }
  }, [groupName, service]);
  const handleSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows(); // Get selected rows
    setSelectedRows(selectedRows);
  };

  const handleCloseQrCodeModal = () => {
    setOpenQrCodeModal(false);
  };

  const handleOpenQrCodeModal = () => {
    if (selectedRows.length === 0) {
      setOpenValidationDialog(true);
      setContentDialog("No Row Selected");
      return;
    }

    // Generate QR code data
    const qrCodes = selectedRows.map(row => ({
      assetno: row.assetCode,
      assetdesc: row.assetDesc,
      assetTypeCode: row.assetTypeCode,
      userDeptCode: row.userDeptCode,
      userLocationCode: row.userLocationCode,
      qrCodeData: `${row.assetCode} - ${row.assetDesc}`,
    }));
    setQrCodeData(qrCodes);
    setOpenQrCodeModal(true);
  };

  const handleDialogClose = () => {
    setOpenValidationDialog(false);
  };
  const handleDialogConfirm = () => {
    setOpenValidationDialog(false);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    let formIsValid = true;
    const newErrors = {
      service: false,
      groupName: false,
      groupDesc: false
    };
    const newErrorMessages = {
      service: "",
      groupName: "",
      groupDesc: "",
    };

    // Validate service
    if (!service) {
      formIsValid = false;
      newErrors.service = true;
      newErrorMessages.service = "Service is required";
    }

    // Validate groupName
    if (!groupName) {
      formIsValid = false;
      newErrors.groupName = true;
      newErrorMessages.groupName = "Group by is required";
    }

    // Validate groupDesc
    if (!groupDesc.label) {
      formIsValid = false;
      newErrors.groupDesc = true;
      newErrorMessages.groupDesc = `${codeLabel} is required`;
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    if (formIsValid) {
      handleClick();
    }
  };
  const handleReset = (e) => {
    setService("");
    setGroupName("");
    setGroupDesc({ label: '' });
    setErrors("");
    setErrorMessages("");
    setRowData([]);
  };

  const handleClick = async () => {
    const groupDescId = groupDesc?.id || "00000000-0000-0000-0000-000000000000";
    const graphApi = service.value === 'FEMS' ? FemsGraph : BemsGraph;
    const apiUrl = `${graphApi}/api/AssetQRCode/GetAssetQRCodeListFetch/${facilityId}/${groupName.id}/${groupDescId}`;

    try {
      const response = await axios.get(apiUrl, config);
      setRowData(response.data);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };
  const handlePrint = useReactToPrint({
    content: () => printRefs.current,
  });

  const handleDownloadPDF = () => {
    html2canvas(printRefs.current, {
      scale: 2,
      useCORS: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [210, 297],
      });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width * 0.264583; // Convert canvas pixels to mm
      const imgHeight = canvas.height * 0.264583; // Convert canvas pixels to mm

      const widthRatio = pdfWidth / imgWidth;
      const heightRatio = pdfHeight / imgHeight;
      const ratio = Math.min(widthRatio, heightRatio);

      const width = imgWidth * ratio;
      const height = imgHeight * ratio;
      const x = (pdfWidth - width) / 2;
      const y = (pdfHeight - height) / 2;

      pdf.addImage(imgData, 'PNG', x, y, width, height);
      pdf.save("AssetQrCode");
    }).catch(error => {
      console.error("Error generating PDF:", error);
    });
  };

  const handleDownloadImage = () => {
    html2canvas(document.querySelector("#qr-code-container")).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = 'AssetQrCode.png';
      link.click();
    });
  };



  return (
    <div>
      <PageTitle title={"Generate Asset QR Code"} />
      <DefaultCard mb={3}>
        <Stack mb={1} direction={"row"} justifyContent={"space-between"} alignItems={"center"} >
          <SectionTitle title={"Asset QR Code Printing List"} />
        </Stack>
        <Grid container spacing={4} >
          <Grid item xs={6} md={3}>
            <CustomSelectInput
              id="service-label"
              label="Service"
              value={service}
              options={serviceOptions}
              getOptionLabel={(option) => option.label}
              onChange={handleServiceChange}
              isMandatoryField={true}
              error={errors.service}
              helperText={errorMessages.service}
              inputRef={serviceAutofoc}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <CustomSelectInput
              id="groupby"
              label="Group by"
              value={groupName}
              options={groupOptions}
              getOptionLabel={(option) => option.label}
              onChange={handleGroupbyChange}
              isMandatoryField={true}
              error={errors.groupName}
              helperText={errorMessages.groupName}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            {groupName && (
              <CustomTextFieldWithSearch
                id="groupby"
                label={codeLabel}
                value={groupDesc}
                options={groupDescriptionOptions}
                getOptionLabel={(option) => option.label}
                onChange={handleGroupDescChange}
                error={errors.groupDesc}
                isMandatoryField={true}
                helperText={errorMessages.groupDesc}

              />
            )}
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Stack direction={"row"} spacing={1.5}>
              <Button sx={{ paddingLeft: "10px", paddingRight: "10px" }} variant="contained" onClick={handleReset} > Reset</Button>
              <Button sx={{ paddingLeft: "10px", paddingRight: "10px" }} variant="contained" onClick={handleSubmit}>Find & Add</Button>
            </Stack>
          </Grid>
        </Grid>
      </DefaultCard>

      <Modal open={openQrCodeModal} onClose={(e, reason) => {
        if (reason !== "backdropClick") {
          handleCloseQrCodeModal();
        }
      }}
        aria-labelledby="qr-code-modal-title"
        aria-describedby="qr-code-modal-description"
      >
        <Box sx={qrCodeModalStyle}>
          {/* <Box   display="flex" justifyContent="flex-end"  > 
            <IconButton onClick={handleCloseQrCodeModal}><CloseIcon /></IconButton>
          </Box> */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2} ml={3}>
            <Typography id="qr-code-modal-title" variant="h3" component="h2">Generated QR Codes </Typography>
            <Box>
              <Button variant="contained" color="primary" onClick={handlePrint} sx={{ mr: 1 }}> Print</Button>
              <Button variant="contained" color="primary" onClick={handleDownloadPDF} sx={{ mr: 1 }}> Download as PDF </Button>
              <Button variant="contained" color="primary" onClick={handleDownloadImage} sx={{ mr: 1 }}>Download as Image </Button>
            </Box>
          </Box>
            {/* Print-specific styles */}
    <style>
      {`
        @media print {
          #qr-code-modal {
            background: none !important; /* Remove background color */
            box-shadow: none !important; /* Remove box shadow */
          }
          #qr-code-container {
            display: block;
            margin: 0 auto;
            width: 100%; /* Set to 100% for full-page width */
            text-align: center;
          }
          #qr-code-container > div {
            page-break-after: always; /* Force a page break after each QR code */
          }
        }
      `}
    </style>

          <Box sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
            {qrCodeData.length > 0 && (
              <div id="qr-code-container" ref={printRefs} style={{ display: 'flex', flexDirection: 'column', gap: '20px',width:'55%' }}>
                {qrCodeData.map(({ assetno, qrCodeData, assetdesc, assetTypeCode, userDeptCode, userLocationCode }) => (
                  <div key={assetno} style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', padding: '10px', border: '1px solid #ccc' }} >   {/* background: '#f9f9f9' */}                 
                    <div style={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                      <QRCode value={qrCodeData} />
                    </div>
                    <div style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <Typography variant="body1"><b>Asset Code:</b> {assetno}</Typography>
                      <Typography variant="body1"><b>Asset Description:</b> {assetdesc}</Typography>
                      <Typography variant="body1"><b>Asset Type Code:</b> {assetTypeCode}</Typography>
                      <Typography variant="body1"><b>User Department Code:</b> {userDeptCode}</Typography>
                      <Typography variant="body1"><b>User Location Code:</b> {userLocationCode}</Typography>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={2} >
            <Button variant="contained" color="primary" onClick={handleCloseQrCodeModal} sx={{ mr: 1 }}>Close</Button>
          </Box>
        </Box>

      </Modal>
      <DefaultCard>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button sx={{ paddingLeft: "10px", marginBottom: "10px" }} variant="contained" onClick={() => handleOpenQrCodeModal()} >Generate QR Code</Button>
          </Grid>
        </Grid>
        <Box>
          <CustomAgGrid
            rows={rowData}
            columns={colDefs}
            ref={gridApi}
            setGridApi={setGridApi}
            onSelectionChanged={handleSelectionChanged}
          />
        </Box>
      </DefaultCard>
      <CloseButton />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Ok"}
      />
    </div>
  )
}
export default CreateAssetQrCode